function WordCount({ input }) {

  return (
    <div className="output2">{input.split(' ').length} words</div>
  )
}

export default WordCount;